import React from 'react';
import LegalPageLayout, { LegalContactBlock, DisputeSettlementBlock } from './LegalPageLayout';
import { LEGAL_SUPPORT_EMAIL } from '../../lib/siteContact';

const PrivacyPolicy = () => (
  <LegalPageLayout
    title="Privacy Policy"
    version="Privacy Policy Version I"
    effectiveDate="19th Apr 2026"
  >
    <p className="legal-page__intro">
      At <strong>Innovative Info Solutions Pvt Ltd</strong>, your privacy is important to us. This
      Privacy Policy explains how we collect, use, disclose, and safeguard your information when you
      visit our website <strong>www.iissms.com</strong> (the &ldquo;Site&rdquo;). Please read this
      policy carefully. If you do not agree with the terms of this policy, please do not access the
      site.
    </p>

    <h2>1. Information We Collect</h2>
    <p>We may collect the following types of information:</p>
    <p>
      <strong>a. Personal Information</strong>
    </p>
    <ul>
      <li>Name</li>
      <li>Email Address</li>
      <li>Phone Number</li>
      <li>Company Name</li>
      <li>Company Address</li>
      <li>Company Nature of Business</li>
      <li>Company GST / MSME / ROC Details</li>
      <li>WhatsApp Business Display Name</li>
      <li>WhatsApp Business Logo</li>
      <li>WhatsApp Templates &amp; Creatives</li>
      <li>User &amp; Business Response</li>
      <li>Campaign Data</li>
    </ul>
    <p>
      <strong>b. Non-Personal Information</strong>
    </p>
    <ul>
      <li>Browser type</li>
      <li>Operating system</li>
      <li>IP address</li>
      <li>Pages visited</li>
      <li>Date and time of visit</li>
      <li>Referring website addresses</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <p>We use collected data to:</p>
    <ul>
      <li>Data of the company to get the approval by <strong>Meta</strong></li>
      <li>Respond to inquiries or customer support requests</li>
      <li>Improve the performance and usability of our platform</li>
      <li>Send Promotional contents &amp; updates</li>
      <li>Analyze user behaviour for website analytics</li>
      <li>Lead &amp; Sales Generation Activity</li>
      <li>Comply with legal obligations</li>
    </ul>

    <h2>3. Sharing of Information</h2>
    <p>
      We do not sell, rent, or trade your personal information to third parties. However, we may
      share information with:
    </p>
    <ul>
      <li>
        <strong>Meta</strong> for the approval &amp; Continued services as per Meta Standard
      </li>
      <li>Trusted third-party service providers who assist us in operating our website</li>
      <li>Legal authorities if required by law</li>
      <li>Business partners in connection with a merger, acquisition, or sale</li>
    </ul>

    <h2>4. Cookies and Tracking Technologies</h2>
    <p>
      We use cookies and similar tracking tools to enhance your user experience and collect data
      about website usage. You can disable cookies through your browser settings, but some features
      of the site may not function properly.
    </p>

    <h2>5. Data Security</h2>
    <p>
      We use administrative, technical, and physical security measures to protect your personal data.
      However, no method of transmission over the Internet or method of electronic storage is 100%
      secure.
    </p>

    <h2>6. Your Rights and Choices</h2>
    <p>Depending on your location, you may have the right to:</p>
    <ul>
      <li>Access, update, or delete your personal data</li>
      <li>Object to or restrict certain types of data processing</li>
      <li>Withdraw consent where processing is based on consent</li>
    </ul>
    <p>
      To exercise your rights, please contact us at{' '}
      <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a>
    </p>

    <h2>7. Third-Party Links</h2>
    <p>
      Our website may contain links to third-party websites. We are not responsible for the content
      or privacy practices of such sites.
    </p>

    <h2>8. Children&apos;s Privacy</h2>
    <p>
      Our website is not intended for children under the age of <strong>18</strong>. We do not
      knowingly collect personal data from children.
    </p>

    <h2>9. Changes to This Privacy Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. The latest version will always be posted
      on this page with the updated effective date.
    </p>

    <h2>10. Contact Us</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at:</p>
    <LegalContactBlock />

    <DisputeSettlementBlock />
  </LegalPageLayout>
);

export default PrivacyPolicy;
